
const getEnv = () => {
  return {
    API_ENDPOINT_URL: process.env.REACT_APP_API_ENDPOINT_URL,
    SITE_URL: process.env.REACT_APP_SITE_URL,
    WS_SOCKET_URL: process.env.REACT_APP_WS_SOCKET_URL,
    WS_SOCKET_PORT: process.env.REACT_APP_WS_SOCKET_PORT,
  };
};

export const env = getEnv();
